import { createSlice } from "@reduxjs/toolkit";

interface AuthState {
  token: string | null;
  step:number | null
}

const initialState: AuthState = {
  token: localStorage.getItem("access_token") || null,
  step:null
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem("access_token", action.payload);
    },
    setReduxStep: (state, action) => {
      state.step = action.payload;
     // localStorage.setItem("step", action.payload);
    },
    logout: (state) => {
      state.token = null;
      localStorage.removeItem("access_token");
      localStorage.removeItem("is_registering"); // Clear the flag
      //localStorage.setItem("is_registering","false");
    },
  },
});

export const { setToken, logout ,setReduxStep} = authSlice.actions;
export default authSlice.reducer;
